import Grid from '@material-ui/core/Grid';
import BaseTable from 'components/Tables/BaseTable';
import { alertError } from 'ducks/alerts';
import { actions } from 'ducks/descriptors';
import React from 'react';
import { connect } from 'react-redux';
import { getImmutableStoreData, lookUpIdValueSelector } from 'selectors/generic';
import columns from 'utils/tables/columns/administration/descriptors';

const Component = props => {
  const { descriptors, descriptorTypes } = props;
  const { create, remove, update } = props;
  const tableRef = React.useRef(null);

  return (
    <Grid item xs={12}>
      <BaseTable
        ref={tableRef}
        columns={columns(descriptorTypes)}
        data={descriptors}
        onRowClick={() => null}
        editable={{
          onRowAdd: newData => create(newData),
          onRowUpdate: newData => update(newData.id, newData),
          onRowDelete: oldData => remove(oldData.id)
        }}
      />
    </Grid>
  )
};

const makeMapStateToProps = () => {
  const immutableDescriptors = getImmutableStoreData('descriptors');
  const descriptorTypes = lookUpIdValueSelector('descriptorTypes', ['id', 'descricao']);
  const mapStateToProps = (state, props) => ({
    descriptors: immutableDescriptors(state),
    descriptorTypes: descriptorTypes(state)
  })
  return mapStateToProps;
}

const mapDispatchToProps = dispatch => ({
  alertError: error => dispatch(alertError(error)),
  create: data => dispatch(actions.createPromise(data)),
  remove: id => dispatch(actions.removePromise(id)),
  update: (id, data) => dispatch(actions.updatePromise(id, data))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
